export const COLOR_ONE = '#323741';
export const COLOR_TWO = '#06858C';
export const COLOR_THREE = '#45C48B';
export const COLOR_FOUR = '#FFD039';
export const COLOR_FIVE = '#EB3E4A';
export const COLOR_SIX = '#2D443A';
export const COLOR_SEVEN = '#2D443A';